import React from 'react'
import SendFeedbackContetn from './Ui/SendFeedbackContent'

const SendFeedback = () => {
  return <SendFeedbackContetn />
}

export default SendFeedback
